import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CAPTAIN_TOOLS_CATALOG_URL: captainToolsCatalogURL,
  CAPTAIN_TOOLS_MANIFEST_ENABLED: captainToolsManifestEnabled,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  IS_COMPANY_ENRICHMENT_ENABLED: isCompanyEnrichmentEnabled,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DISABLE_META_INBOX_CREATION: disableMetaInboxCreation,
  DISABLE_META_MESSAGE_SENDING: disableMetaMessageSending,
  DEPLOYMENT_ENV: deploymentEnv,
  BAILEYS_WHATSAPP_GROUPS_ENABLED: baileysWhatsappGroupsEnabled,
  FAZER_AI_SUBSCRIPTION: fazerAiSubscription,
  ACTIVE_PLATFORM_BANNERS: activePlatformBanners,
  ACTIVE_FEATURE_ANNOUNCEMENTS: activeFeatureAnnouncements,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  captainToolsCatalogURL,
  captainToolsManifestEnabled: parseBoolean(captainToolsManifestEnabled),
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  disableMetaInboxCreation: parseBoolean(disableMetaInboxCreation),
  disableMetaMessageSending: parseBoolean(disableMetaMessageSending),
  displayManifest,
  gitSha,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  baileysWhatsappGroupsEnabled: parseBoolean(baileysWhatsappGroupsEnabled),
  fazerAiSubscription: fazerAiSubscription || {},
  isCompanyEnrichmentEnabled: parseBoolean(isCompanyEnrichmentEnabled),
  activePlatformBanners: activePlatformBanners || [],
  activeFeatureAnnouncements: activeFeatureAnnouncements || [],
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isMetaInboxCreationDisabled: $state =>
    $state.deploymentEnv === 'cloud' && $state.disableMetaInboxCreation,
  isMetaMessageSendingDisabled: $state =>
    $state.deploymentEnv === 'cloud' && $state.disableMetaMessageSending,
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
  getFazerAiSubscription: $state => $state.fazerAiSubscription,
  isFazerAiSubscriptionPastDue: $state =>
    $state.fazerAiSubscription?.status === 'past_due',
  isFazerAiSubscriptionTrialing: $state =>
    $state.fazerAiSubscription?.status === 'trialing',
  isFazerAiSubscriptionCanceling: $state =>
    $state.fazerAiSubscription?.cancel_at_period_end === true,
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
